var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { position: "absolute", "z-index": "1" },
      attrs: { title: "Configurações Gerais" }
    },
    [
      _c(
        "b-dropdown",
        {
          ref: "dropdown",
          staticStyle: {
            width: "29px",
            height: "32px",
            position: "fixed",
            "z-index": "11",
            right: "10px",
            top: "12px",
            display: "inline-flex !important",
            background: "#fff",
            "border-radius": "4px",
            "box-shadow": "0 0 0 2px rgba(0, 0, 0, .1) !important"
          },
          attrs: {
            title: "Configurações",
            id: "menu",
            size: "lg",
            variant: "link",
            "toggle-class": "text-decoration-none btnConfig",
            "no-caret": ""
          },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function() {
                return [
                  _c(
                    "svg",
                    {
                      staticStyle: {
                        position: "absolute",
                        left: "17.5%",
                        right: "12.5%",
                        top: "6px !important",
                        bottom: "12.5%"
                      },
                      attrs: {
                        id: "svg-menu",
                        title: "Configurações",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477 4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897 15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512 15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974 13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789 11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348 7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479 4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648 4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29083 4.99167 8.37417 4.54333 8.60417 3.5975Z",
                          stroke: "#6A707C",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5C10.663 7.5 11.2989 7.76339 11.7678 8.23223C12.2366 8.70107 12.5 9.33696 12.5 10V10Z",
                          stroke: "#6A707C",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          false
            ? _c(
                "b-dd-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.OpenColumnChooser()
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 13 13",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M1.5 2.125C1.5 1.95924 1.56585 1.80027 1.68306 1.68306C1.80027 1.56585 1.95924 1.5 2.125 1.5H10.875C11.0408 1.5 11.1997 1.56585 11.3169 1.68306C11.4342 1.80027 11.5 1.95924 11.5 2.125V3.375C11.5 3.54076 11.4342 3.69973 11.3169 3.81694C11.1997 3.93415 11.0408 4 10.875 4H2.125C1.95924 4 1.80027 3.93415 1.68306 3.81694C1.56585 3.69973 1.5 3.54076 1.5 3.375V2.125ZM1.5 7.125C1.5 6.95924 1.56585 6.80027 1.68306 6.68306C1.80027 6.56585 1.95924 6.5 2.125 6.5H5.875C6.04076 6.5 6.19973 6.56585 6.31694 6.68306C6.43415 6.80027 6.5 6.95924 6.5 7.125V10.875C6.5 11.0408 6.43415 11.1997 6.31694 11.3169C6.19973 11.4342 6.04076 11.5 5.875 11.5H2.125C1.95924 11.5 1.80027 11.4342 1.68306 11.3169C1.56585 11.1997 1.5 11.0408 1.5 10.875V7.125ZM9 7.125C9 6.95924 9.06585 6.80027 9.18306 6.68306C9.30027 6.56585 9.45924 6.5 9.625 6.5H10.875C11.0408 6.5 11.1997 6.56585 11.3169 6.68306C11.4342 6.80027 11.5 6.95924 11.5 7.125V10.875C11.5 11.0408 11.4342 11.1997 11.3169 11.3169C11.1997 11.4342 11.0408 11.5 10.875 11.5H9.625C9.45924 11.5 9.30027 11.4342 9.18306 11.3169C9.06585 11.1997 9 11.0408 9 10.875V7.125Z",
                          stroke: "#3C434D",
                          "stroke-width": "1.2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  ),
                  _vm._v("   Templates de Colunas\n    ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-dd-item",
            {
              on: {
                click: function($event) {
                  return _vm.OpenConfigStatus()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M1.5 9.625C1.5 10.1223 1.69754 10.5992 2.04917 10.9508C2.40081 11.3025 2.87772 11.5 3.375 11.5H9.625C10.1223 11.5 10.5992 11.3025 10.9508 10.9508C11.3025 10.5992 11.5 10.1223 11.5 9.625M9 4L6.5 1.5M6.5 1.5L4 4M6.5 1.5V9",
                      stroke: "#3C434D",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              ),
              _vm._v("   Status Upload\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-dd-item",
            {
              on: {
                click: function($event) {
                  return _vm.OpenAdmin()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "13",
                    height: "9",
                    viewBox: "0 0 13 9",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M12.125 1.375L7.125 6.375L4.625 3.875L0.875 7.625M7.125 1.375H12.125H7.125ZM12.125 1.375V6.375V1.375Z",
                      stroke: "#3C434D",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              ),
              _vm._v("  Administração\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-form",
            { staticStyle: { "margin-top": "5px", "margin-bottom": "5px" } },
            [
              _c(
                "svg",
                {
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M1.5 2.125C1.5 1.95924 1.56585 1.80027 1.68306 1.68306C1.80027 1.56585 1.95924 1.5 2.125 1.5H10.875C11.0408 1.5 11.1997 1.56585 11.3169 1.68306C11.4342 1.80027 11.5 1.95924 11.5 2.125V3.375C11.5 3.54076 11.4342 3.69973 11.3169 3.81694C11.1997 3.93415 11.0408 4 10.875 4H2.125C1.95924 4 1.80027 3.93415 1.68306 3.81694C1.56585 3.69973 1.5 3.54076 1.5 3.375V2.125ZM1.5 7.125C1.5 6.95924 1.56585 6.80027 1.68306 6.68306C1.80027 6.56585 1.95924 6.5 2.125 6.5H5.875C6.04076 6.5 6.19973 6.56585 6.31694 6.68306C6.43415 6.80027 6.5 6.95924 6.5 7.125V10.875C6.5 11.0408 6.43415 11.1997 6.31694 11.3169C6.19973 11.4342 6.04076 11.5 5.875 11.5H2.125C1.95924 11.5 1.80027 11.4342 1.68306 11.3169C1.56585 11.1997 1.5 11.0408 1.5 10.875V7.125ZM9 7.125C9 6.95924 9.06585 6.80027 9.18306 6.68306C9.30027 6.56585 9.45924 6.5 9.625 6.5H10.875C11.0408 6.5 11.1997 6.56585 11.3169 6.68306C11.4342 6.80027 11.5 6.95924 11.5 7.125V10.875C11.5 11.0408 11.4342 11.1997 11.3169 11.3169C11.1997 11.4342 11.0408 11.5 10.875 11.5H9.625C9.45924 11.5 9.30027 11.4342 9.18306 11.3169C9.06585 11.1997 9 11.0408 9 10.875V7.125Z",
                      stroke: "#3C434D",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              ),
              _vm._v("   Tema\n      "),
              _c(
                "svg",
                {
                  staticStyle: { "margin-left": "10px", "margin-top": "-3px" },
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M13 9.09589C11.8678 9.55102 10.6267 9.66349 9.43101 9.41931C8.23535 9.17513 7.13784 8.58507 6.27492 7.72248C5.41199 6.85989 4.8217 5.76281 4.57743 4.56761C4.33315 3.37241 4.44567 2.1318 4.90098 1C3.56016 1.53986 2.44897 2.52914 1.75789 3.79824C1.0668 5.06734 0.83887 6.53722 1.11316 7.9559C1.38746 9.37459 2.1469 10.6537 3.26129 11.574C4.37568 12.4943 5.77562 12.9984 7.22111 13C8.46413 13 9.67873 12.6283 10.7086 11.9325C11.7385 11.2367 12.5365 10.2488 13 9.09589Z",
                      stroke: "#3C434D",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("toggle-button", {
                staticStyle: {
                  "z-index": "999999",
                  margin: "-2px 2px 0px 2px",
                  "margin-left": "5px"
                },
                attrs: { color: "#23A6F0" },
                model: {
                  value: _vm.darkmode,
                  callback: function($$v) {
                    _vm.darkmode = $$v
                  },
                  expression: "darkmode"
                }
              }),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticStyle: { "margin-top": "-3px" },
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M7 1V1.66667V1ZM7 12.3333V13V12.3333ZM13 7H12.3333H13ZM1.66667 7H1H1.66667ZM11.2427 11.2427L10.7713 10.7713L11.2427 11.2427ZM3.22867 3.22867L2.75733 2.75733L3.22867 3.22867ZM11.2427 2.75733L10.7713 3.22867L11.2427 2.75733ZM3.22867 10.7713L2.75733 11.2427L3.22867 10.7713ZM9.66667 7C9.66667 7.70724 9.38572 8.38552 8.88562 8.88562C8.38552 9.38572 7.70724 9.66667 7 9.66667C6.29276 9.66667 5.61448 9.38572 5.11438 8.88562C4.61428 8.38552 4.33333 7.70724 4.33333 7C4.33333 6.29276 4.61428 5.61448 5.11438 5.11438C5.61448 4.61428 6.29276 4.33333 7 4.33333C7.70724 4.33333 8.38552 4.61428 8.88562 5.11438C9.38572 5.61448 9.66667 6.29276 9.66667 7V7Z",
                      stroke: "#3C434D",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-dd-item",
            {
              on: {
                click: function($event) {
                  return _vm.LogOff()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 13 13",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M7.125 9V9.625C7.125 10.1223 6.92746 10.5992 6.57583 10.9508C6.22419 11.3025 5.74728 11.5 5.25 11.5H2.75C2.25272 11.5 1.77581 11.3025 1.42417 10.9508C1.07254 10.5992 0.875 10.1223 0.875 9.625V3.375C0.875 2.87772 1.07254 2.40081 1.42417 2.04917C1.77581 1.69754 2.25272 1.5 2.75 1.5H5.25C5.74728 1.5 6.22419 1.69754 6.57583 2.04917C6.92746 2.40081 7.125 2.87772 7.125 3.375V4M9.625 9L12.125 6.5L9.625 9ZM12.125 6.5L9.625 4L12.125 6.5ZM12.125 6.5H3.375H12.125Z",
                      stroke: "#3C434D",
                      "stroke-width": "1.2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }
                  })
                ]
              ),
              _vm._v("  Sair\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              attrs: {
                disabled: "",
                title: "Versão: " + _vm.version + " | Build: " + _vm.buildDate
              }
            },
            [_c("small", [_vm._v(_vm._s(_vm.environment))])]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { overflow: "hidden" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _vm.CogSlideModal
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      background: "#f2f2f2",
                      border: "1px solid",
                      "z-index": "100",
                      top: "45px",
                      left: "0",
                      width: "350px",
                      height: "1900px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-left": "20px",
                          "margin-top": "5px",
                          "margin-right": "5px"
                        }
                      },
                      [
                        _c(
                          "b-row",
                          {
                            staticStyle: {
                              height: "35px",
                              "padding-top": "5px"
                            }
                          },
                          [
                            _c("b-col", { attrs: { cols: "4" } }, [
                              _c(
                                "a",
                                {
                                  staticStyle: { color: "#818082" },
                                  attrs: { href: "javascript:void(0)" },
                                  on: { click: _vm.HideAndShowCogSlide }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-angle-double-left "
                                  })
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("b-col", [
                              _c("h5", [_vm._v("Gerenciador de Camadas")])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-list-group",
                              { staticStyle: { width: "97%" } },
                              [
                                _c(
                                  "b-list-group-item",
                                  {
                                    attrs: { href: "#", variant: "light" },
                                    on: { click: _vm.OpenBusinessFilter }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex w-100 justify-content-between"
                                      },
                                      [
                                        _c("h6", { staticClass: "mb-1" }, [
                                          _vm._v("Smartleads Business")
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-list-group-item",
                                  {
                                    attrs: { href: "#", variant: "light" },
                                    on: { click: _vm.OpenPeopleFilter }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex w-100 justify-content-between"
                                      },
                                      [
                                        _c("h6", { staticClass: "mb-1" }, [
                                          _vm._v("Smartleads People")
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-list-group-item",
                                  { attrs: { href: "#", variant: "light" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex w-100 justify-content-between"
                                      },
                                      [
                                        _c("h6", { staticClass: "mb-1" }, [
                                          _vm._v("Geopop")
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-list-group-item",
                                  { attrs: { href: "#", variant: "light" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex w-100 justify-content-between"
                                      },
                                      [
                                        _c(
                                          "b-btn-group",
                                          { staticStyle: { width: "100%" } },
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-popover",
                                                    rawName:
                                                      "v-b-popover.hover.bottom",
                                                    value: {
                                                      customClass:
                                                        "tooltip-class",
                                                      content: "Nova Tabela"
                                                    },
                                                    expression:
                                                      "{ customClass: 'tooltip-class', content: 'Nova Tabela' }",
                                                    modifiers: {
                                                      hover: true,
                                                      bottom: true
                                                    }
                                                  }
                                                ],
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  variant: "outline-info"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.OpenUpload()
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Nova Tabela / Upload "
                                                ),
                                                _c("i", {
                                                  staticClass: "fas fa-plus"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-row", [_c("LayerVisibility")], 1)
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _vm.CogSlideModalSecondary
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      background: "#f2f2f2",
                      border: "1px solid",
                      "z-index": "51",
                      top: "45px",
                      left: "350px",
                      height: "1900px"
                    },
                    style: { width: _vm.sizeSecondaryModal + "%" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-left": "20px",
                          "margin-top": "5px",
                          "margin-right": "5px"
                        }
                      },
                      [
                        _c(
                          "b-row",
                          {
                            staticStyle: {
                              height: "35px",
                              "padding-top": "5px"
                            }
                          },
                          [
                            _c("b-col", { attrs: { cols: "4" } }),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticStyle: {
                                  "max-width": "100%",
                                  "min-width": "100%"
                                }
                              },
                              [
                                _vm.UploadModal
                                  ? _c("UploadPage", {
                                      on: { modalClose: _vm.modalClose }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }